"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.yourProfileSchema = exports.YourProfileFields = void 0;
const yup = __importStar(require("yup"));
const MIN_LENGTH = 2;
const MAX_LENGTH = 100;
const MAX_PHONE_LENGTH = 20;
var YourProfileFields;
(function (YourProfileFields) {
    YourProfileFields["FIRST_NAME"] = "firstName";
    YourProfileFields["LAST_NAME"] = "lastName";
    YourProfileFields["PHONE"] = "phone";
})(YourProfileFields = exports.YourProfileFields || (exports.YourProfileFields = {}));
const yourProfileSchema = (t) => yup.object({
    firstName: yup
        .string()
        .matches(/^[^0-9]*$/, {
        message: { message: t('/haldex/my_profile/first_name_not_valid'), field: YourProfileFields.FIRST_NAME }
    })
        .min(MIN_LENGTH, { message: t('/haldex/my_profile/first_name_min'), field: YourProfileFields.FIRST_NAME })
        .max(MAX_LENGTH, { message: t('/haldex/my_profile/first_name_max'), field: YourProfileFields.FIRST_NAME })
        .required({ message: t('/haldex/my_profile/first_name_reqiured'), field: YourProfileFields.FIRST_NAME }),
    lastName: yup
        .string()
        .matches(/^[^0-9]*$/, {
        message: { message: t('/haldex/my_profile/last_name_not_valid'), field: YourProfileFields.LAST_NAME }
    })
        .max(MAX_LENGTH, { message: t('/haldex/my_profile/last_name_max'), field: YourProfileFields.LAST_NAME })
        .min(MIN_LENGTH, { message: t('/haldex/my_profile/last_name_min'), field: YourProfileFields.LAST_NAME })
        .required({ message: t('/haldex/my_profile/last_name_required'), field: YourProfileFields.LAST_NAME }),
    phone: yup
        .string()
        .matches(/^[^a-zA-Z]*$/, {
        message: { message: t('/haldex/my_profile/phone_not_valid'), field: YourProfileFields.PHONE }
    })
        .max(MAX_PHONE_LENGTH, { message: t('/haldex/my_profile/phone_max'), field: YourProfileFields.PHONE })
        .required({ message: t('/haldex/my_profile/phone_required'), field: YourProfileFields.PHONE })
});
exports.yourProfileSchema = yourProfileSchema;
